import { defineStore } from 'pinia';
import type { AuraProcessingCostsFilters, SortMenuItem } from '@/types';
import { endOfUtcDay, normalizeUtcDateRange, startOfUtcDay } from '@/utils/datetime';

const getInitialFilters = (): AuraProcessingCostsFilters => {
    const today = new Date();
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

    return {
        dateFrom: startOfUtcDay(monthStart).toISOString(),
        dateTo: endOfUtcDay(today).toISOString(),
        page: 1,
        perPage: 25,
    };
};

const normalizeFilters = (filters: AuraProcessingCostsFilters): AuraProcessingCostsFilters => {
    if (!filters.dateFrom || !filters.dateTo) return filters;

    const [dateFrom, dateTo] = normalizeUtcDateRange(filters.dateFrom, filters.dateTo);
    return {
        ...filters,
        dateFrom: dateFrom.toISOString(),
        dateTo: dateTo.toISOString(),
    };
};

export const useAuraProcessingCostsStore = defineStore('auraProcessingCosts', {
    state: () => ({
        filters: getInitialFilters(),
        sortMenuSelected: [] as SortMenuItem[],
    }),

    actions: {
        setFilters(filters: AuraProcessingCostsFilters): void {
            this.filters = normalizeFilters(filters);
        },

        resetFilters(): void {
            this.filters = getInitialFilters();
        },

        setSortMenuSelected(items: SortMenuItem[]): void {
            this.sortMenuSelected = items;
        },
    },
});
